import React from "react";
import classNames from "classnames";
import Icon from "../icon/Icon";
import Indicator from "../bits/Indicator";
import Spinner from "../spinner/Spinner";
const ButtonContent = props => {
    const labelClassName = classNames("gui-button__label", {
        "m-text-left": props.style === "link",
        "m-nowrap": props.nowrap === false ? false : props.style === "link" || props.nowrap
    });
    const renderIconAndLabel = () => {
        const label = (React.createElement("span", { className: labelClassName, key: "label" }, props.label || props.children));
        if (!props.icon) {
            return label;
        }
        const icon = props.icon ? (React.createElement("span", { className: "gui-button__icon", key: "icon" },
            React.createElement(Icon, { icon: props.icon, block: props.small }))) : null;
        if (props.iconPosition === "right") {
            return [label, icon];
        }
        return [icon, label];
    };
    const className = classNames("gui-button__content", {
        "gui-button__content--noIcon": !props.icon,
        "gui-button__content--nohover": props.linkhovereffect
    });
    return (React.createElement("span", { className: className },
        props.pending ? (React.createElement("span", { className: "gui-button__spinner" },
            React.createElement(Spinner, { size: "small" }))) : null,
        props.important ? React.createElement(Indicator, { type: "important", placement: "left" }) : null,
        renderIconAndLabel()));
};
export default ButtonContent;
//# sourceMappingURL=ButtonContent.js.map